import { ENTITLEMENT_FEATURES } from "@/common/fields/plan-features";

const _byPrice = (plans) => [...plans].sort((a, b) => a.price - b.price);

const _entitlementLimit = (plan, resourceCode) => {
    const entitlement = (plan.entitlements || []).find(
        (item) => item.resourceCode === resourceCode
    );
    return entitlement ? entitlement.quantity : 0;
};

const _toPlanSummary = (plan, limit) => ({
    slug: plan.slug,
    code: plan.code,
    name: plan.name,
    price: plan.price,
    ...(limit !== undefined && { limit })
});

const _includesFeature = (plan, feature) => {
    if (ENTITLEMENT_FEATURES.includes(feature)) {
        const limit = _entitlementLimit(plan, feature);
        return limit === null || limit > 0;
    }
    return (plan.features || []).includes(feature);
};

const getters = {
    // Plan activo más barato que incluye la feature (null si ninguno).
    unlockPlanForFeature: (state) => (feature) => {
        const plan = _byPrice(state.planCatalog).find((item) =>
            _includesFeature(item, feature)
        );
        return plan ? _toPlanSummary(plan) : null;
    },
    // Plan activo más barato cuyo tope supera lo usado (mismo criterio que
    // el `upgradePlan` del backend).
    upgradePlanForResource: (state) => (resourceCode, used) => {
        const plan = _byPrice(state.planCatalog).find((item) => {
            const limit = _entitlementLimit(item, resourceCode);
            return limit === null || limit > used;
        });
        return plan
            ? _toPlanSummary(plan, _entitlementLimit(plan, resourceCode))
            : null;
    },
    planBySlug: (state) => (slug) =>
        state.planCatalog.find((plan) => plan.slug === slug) || null,
    freePlan: (state) =>
        state.planCatalog.find((plan) => plan.code === "free") || null
};

export default getters;
